<section class="hero is-primary mb-8">
  <div class="container-full">
    <div class="container">
      <div>
        <div>
          <div class="hero-body px-0 py-9">
            <div class="columns">
              <div class="column is-8-tablet is-12-widescreen">
                <div class="is-flex align-items-center mb-4">
                  <h1 class="title is-2 has-text-weight-bold mr-10">
                    Monitoring Tax Support for R&D and Innovation
                  </h1>
                </div>
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column column--cta is-3-desktop">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-space-between is-fullheight"
                >
                  <div
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-direction-column"
                  >
                    <figure class="image">
                      <i class="fa-solid fa-globe is-size-4 mb-2"></i>
                    </figure>
                    <p class="has-text-weight-bold mt-2 mb-6 mb-0-mobile">
                      Explore tax incentives for R&D and innovation within one country
                    </p>
                  </div>
                  <a
                    routerLink="/countries"
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start has-text-link has-text-weight-bold"
                  >
                    <i class="fas fa-arrow-right-long mr-1"></i>
                    <span class="has-text-weight-bold">Explore a country</span>
                  </a>
                </div>
              </div>
              <div class="column column--cta is-3-desktop">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-space-between is-fullheight"
                >
                  <div
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-direction-column"
                  >
                    <figure class="image">
                      <i class="fa-solid fa-chart-simple is-size-4 mb-2"></i>
                    </figure>

                    <p class="has-text-weight-bold mt-2 mb-6 mb-0-mobile">
                      Review the latest indicators and OECD analysis on tax incentives for R&D and innovation
                    </p>
                  </div>
                  <a
                    routerLink="/indicators-and-analysis"
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start has-text-link has-text-weight-bold"
                  >
                    <i class="fas fa-arrow-right-long mr-1"></i>
                    <span class="has-text-weight-bold">Access indicators</span>
                  </a>
                </div>
              </div>
              <div class="column column--cta is-3-desktop">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-space-between is-fullheight"
                >
                  <div
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-direction-column"
                  >
                    <figure class="image">
                      <i class="fa-solid fa-book-open is-size-4 mb-2"></i>
                    </figure>
                    <p class="has-text-weight-bold mt-2 mb-6 mb-0-mobile">
                      Search and compare the design of tax incentives for R&D and innovation
                    </p>
                  </div>
                  <a
                    routerLink="/incentives"
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start has-text-link has-text-weight-bold"
                  >
                    <i class="fas fa-arrow-right-long mr-1"></i>
                    <span class="has-text-weight-bold"
                      >Select tax incentives</span
                    >
                  </a>
                </div>
              </div>
              <div class="column column--cta is-12-touch is-3-desktop pt-0">
                <app-country-comparison-widget></app-country-comparison-widget>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container">
  <!-- Data visualization -->
  <div>
    <div>
      <h2 class="title is-3 has-text-weight-bold has-line pb-4">
        Tax incentives for R&D and innovation in the OECD area and beyond
      </h2>
    </div>
  </div>
  <app-aggregation-widget
    [loading]="loadingAggregations"
    [aggregations]="aggregations"
    [layout]="'overview'"
  ></app-aggregation-widget>
</div>

<div class="container">
  <!-- Data visualization -->
  <div>
    <div class="pt-4">
      <h2 class="title is-3 has-text-weight-bold has-line mt-4 pb-4">
        Design of tax incentives for R&D and innovation
      </h2>
    </div>
  </div>

  <app-aggregation-widget
    [loading]="loadingAggregations"
    [aggregations]="aggregations"
  ></app-aggregation-widget>


  <div class="container" *ngIf="governmentTaxSupportCombined">
    <!-- Data visualization -->
    <div>
      <div class="pt-4">
        <h2 class="title is-3 has-text-weight-bold has-line mt-6">
          Government tax support for business R&D and innovation
        </h2>
        <div class="content">
          <app-aggregation-wrapper
            [aggregation] = governmentTaxSupportCombined
            [applyStyling] = false
          ></app-aggregation-wrapper>
        </div>
      </div>
    </div>
  </div>

  <div class="columns" *ngIf="false">
    <div class="">
      <h2 class="title is-3 has-text-weight-bold has-line mt-4">
        Generosity of R&D tax incentives
      </h2>
      <div class="content">
        <p>
          Implied tax subsidy rates on R&D tax incentives, calculated as 1 minus
          the
          <a
            target="_blank"
            href="https://one.oecd.org/document/DSTI/STP/NESTI(2023)2/FINAL/en/pdf"
            download
            >B-Index</a
          >, provide a synthetic representation of the generosity of the tax
          system in incentivising business R&D investment.
        </p>
        <p>
          <a
            routerLink="/indicators-and-analysis"
            class="icon-text no-deco ml-1"
          >
            <span class="icon">
              <i class="fas fa-circle-right mr-1 has-text-link"></i>
            </span>
            <span
              >Explore additional OECD indicators and analysis on R&D tax
              incentives</span
            >
          </a>
        </p>
      </div>
    </div>
  </div>

  <app-aggregation-widget
    [loading]="loadingAggregations"
    [aggregations]="[otherAggregation]"
    *ngIf="false"
  ></app-aggregation-widget>

  <div class="columns mt-4 mb-8 m-0" *ngIf="additionalResources">
    <div class="is-12">
      <div class="card card--info has-background-white-bis is-fullheight is-shadowless">
        <div class="card-content p-8 p-4-mobile">

          <div class="resources-header">
            <h2 class="title is-3 has-text-weight-bold has-line">
              Additional resources
            </h2>

            <a
              [routerLink]="['/indicators-and-analysis']"
              fragment="resources"
              class="discover-link"
            >
              Discover other resources and related work
              <span class="icon">
              <i class="fas fa-circle-right"></i>
            </span>
            </a>
          </div>

          <p class="intro-text">
            Tax incentives have become a major tool in the business innovation
            support policy mix of countries in the OECD area and beyond. Since
            2007, the OECD has continuously worked to extend the international
            evidence on the use, generosity, cost and impacts of tax incentives
            for R&D expenditure and related tax relief provisions for R&D and innovation income.
          </p>
          <p class="intro-text">
            Recent OECD publications include:
          </p>

          <div class="resources-grid">
            <div
              class="resource-item mb-4"
              *ngFor="let additionalResource of additionalResources"
            >
              <div class="resource-icon">
                <i class="fas fa-link"></i>
              </div>

              <a
                class="resource-title"
                [href]="additionalResource.link"
                target="_blank"
              >
                {{ additionalResource.anchor }}
              </a>

              <div
                class="resource-extra"
                *ngIf="additionalResource['extra-text']"
              >
                {{ additionalResource['extra-text']['pre-title'] }}
                <a
                  [href]="additionalResource['extra-text'].link"
                  target="_blank"
                >
                  {{ additionalResource['extra-text'].anchor }}
                </a>
                {{ additionalResource['extra-text']['post-title'] }}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
